import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractWording from "../Wording";

class Wording extends AbstractWording {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-wordings-ipr';
  }
}

export default Wording;
